import { z } from "zod";
import { accountTypeSchema } from "./account.schema";

export const ACCOUNT_GROUP_NAME_MAX_LENGTH = 80;

export const entityAccountGroupSchema = z.object({
    id: z.string().uuid(),
    entityId: z.number().int(),
    name: z.string(),
    type: accountTypeSchema,
    parentGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
});

export type EntityAccountGroupSchema = z.infer<typeof entityAccountGroupSchema>;

export const createAccountGroupBodySchema = z.object({
    name: z.string().trim().min(1).max(ACCOUNT_GROUP_NAME_MAX_LENGTH),
    type: accountTypeSchema,
    parentGroupId: z.string().uuid().nullable().optional(),
    initialChildAccountIds: z.array(z.string().uuid()).max(500).optional(),
});

export type CreateAccountGroupBody = z.infer<
    typeof createAccountGroupBodySchema
>;

export const updateAccountGroupBodySchema = z
    .object({
        name: z
            .string()
            .trim()
            .min(1)
            .max(ACCOUNT_GROUP_NAME_MAX_LENGTH)
            .optional(),
        type: accountTypeSchema.optional(),
        accountIds: z.array(z.string().uuid()).max(500).optional(),
        parentGroupId: z.string().uuid().nullable().optional(),
    })
    .refine(
        (body) =>
            body.name !== undefined ||
            body.type !== undefined ||
            body.accountIds !== undefined ||
            body.parentGroupId !== undefined,
        { message: "At least one field must be provided" },
    );

export type UpdateAccountGroupBody = z.infer<
    typeof updateAccountGroupBodySchema
>;

export const bulkDeleteAccountGroupItemSchema = z.object({
    groupId: z.string().uuid(),
    entityId: z.number(),
});

export type BulkDeleteAccountGroupItem = z.infer<
    typeof bulkDeleteAccountGroupItemSchema
>;

export const bulkDeleteAccountGroupsBodySchema = z.array(
    bulkDeleteAccountGroupItemSchema,
);

export type BulkDeleteAccountGroupsBody = z.infer<
    typeof bulkDeleteAccountGroupsBodySchema
>;

export const bulkDeleteAccountGroupResponseItemSchema = z.object({
    id: z.string().uuid(),
    success: z.boolean(),
});

export const groupFormValuesSchema = z.object({
    name: z.string().trim().min(1).max(ACCOUNT_GROUP_NAME_MAX_LENGTH),
    type: accountTypeSchema,
    parentGroupId: z.string().uuid().nullable().optional(),
    accountIds: z.array(z.string().uuid()).max(500),
});

export type GroupFormValuesSchema = z.infer<typeof groupFormValuesSchema>;
